import React from "react";
import {
  withStyles,
  withTheme,
  List,
  ListItem,
  ListItemIcon,
  Collapse,
  withWidth,
} from "@material-ui/core";
import {
  DnsOutlined as DnsOutlinedIcon,
  GroupOutlined as GroupOutlinedIcon,
  GroupAddOutlined,
  EventNoteSharp,
  TrendingUp as TrendingUpIcon,
  AssessmentOutlined as AssessmentIcon,
  VerifiedUserOutlined as VerifiedUserOutlinedIcon
} from "@material-ui/icons";
import styles from "../moduleViewstyles";
import { compose } from "recompose";
import Events from "../../../utilities/EventEmitter";
import Tooltip from "../../common/StyledToolTip";
import appConstant, { USER_ROLE } from "../../../appConstants";
import NextStopComplianceMarker from "../../mapComponents/Markers/NextStopCompliance/NextStopComplienceMarker";
import StripTrailerIcon from "./TrailerStripPriority/components/StripTrailerIcon";
import NotesIcon from '@material-ui/icons/Notes';

import DriverPerformanceHistoricMarker from "./DriverPerformance/components/HistoricMarker";
import { withUserProfile } from "../../../userProfile/userProfileContext";

const ReportList = (props) => {
  const onModuleChange = (event) => {
    const newModuleURL = event.target.getAttribute("data-moduleurl");
    if (newModuleURL && props.activeModule !== newModuleURL) {
      Events.emit("RedirectToPage", "null", newModuleURL);
    }
  };

  const displayTitle = (width, title) => {
    return ["xl", "lg"].includes(width) ? "" : title;
  };

  const hasAccess = (allowedRoles = []) => {
    const { isAdmin, roles } = props?.userData?.userProfile || {};
    if (isAdmin) return true;
    return allowedRoles.some(role => roles?.includes(role));
  }

  const {
    classes,
    theme,
    activeModule,
    enableNextStopComplianceReport,
    enableDriverPerformanceHistoricReport,
    enableRecordsLookupReport,
    enableIBStripPriorityReport,
    enableRouteAudit
  } = props;
  const { NAV_URLS } = appConstant;
  const { isAdmin } = props?.userData?.userProfile || {};
  return (
    <div className={`${classes.leftSection} ${classes.reports}`}>
      <List onClick={onModuleChange}>
        <Collapse in={true}>
          <List classes={{ root: classes.innerListRoot }} component="nav">
            <Tooltip title={displayTitle(props.width, "Duplicate Customers")}>
              <ListItem
                button
                classes={{
                  root: `${classes.reportsListItem} ${classes.listItemRoot}`,
                  selected: classes.listItemSelected,
                }}
                data-moduleurl={NAV_URLS.REPORT_DUPLICATE_CUSTOMERS}
                selected={activeModule === NAV_URLS.REPORT_DUPLICATE_CUSTOMERS}
              >
                <ListItemIcon classes={{ root: classes.iconStyle }}>
                  <GroupOutlinedIcon className={`${classes.kpiIcon}`} />
                </ListItemIcon>
                <span className={classes.reportsListLabel}>
                  Duplicate Customers
                </span>
              </ListItem>
            </Tooltip>
            <Tooltip
              title={displayTitle(props.width, "IB Trailer Strip Priority")}
            >
              <ListItem
                button
                classes={{
                  root: `${classes.reportsListItem} ${classes.listItemRoot}`,
                  selected: classes.listItemSelected,
                }}
                data-moduleurl={NAV_URLS.REPORT_TRAILER_STRIP_PRIORITY}
                selected={activeModule === NAV_URLS.REPORT_TRAILER_STRIP_PRIORITY}
                disabled={!enableIBStripPriorityReport}>
                <ListItemIcon classes={{ root: classes.iconStyle }}>
                  <StripTrailerIcon
                    color={
                      activeModule === NAV_URLS.REPORT_TRAILER_STRIP_PRIORITY
                        ? theme.selectedStopMarkerColor
                        : theme.HeaderSelectedText
                    }
                    className={`${classes.dcrIcon} icon-dcr`}
                  />
                </ListItemIcon>
                <span className={classes.reportsListLabel}>
                  IB Trailer Strip Priority
                </span>
              </ListItem>
            </Tooltip>
            <Tooltip title={displayTitle(props.width, "Merged Customers")}>
              <ListItem
                button
                classes={{
                  root: `${classes.reportsListItem} ${classes.listItemRoot}`,
                  selected: classes.listItemSelected,
                }}
                data-moduleurl={NAV_URLS.REPORT_MERGED_CUSTOMERS}
                selected={activeModule === NAV_URLS.REPORT_MERGED_CUSTOMERS}
              >
                <ListItemIcon classes={{ root: classes.iconStyle }}>
                  <GroupAddOutlined
                    className={`${classes.mergedCustomerIcon}`}
                  />
                </ListItemIcon>
                <span className={classes.reportsListLabel}>
                  Grouped Customers
                </span>
              </ListItem>
            </Tooltip>
            {isAdmin ? (
              <Tooltip
                title={displayTitle(props.width, "IB Planning Operations")}
              >
                <ListItem
                  button
                  classes={{
                    root: `${classes.reportsListItem} ${classes.listItemRoot}`,
                    selected: classes.listItemSelected,
                  }}
                  data-moduleurl={NAV_URLS.REPORT_IBPSUMMARY}
                  selected={activeModule === NAV_URLS.REPORT_IBPSUMMARY}
                >
                  <ListItemIcon classes={{ root: classes.iconStyle }}>
                    <i className="icon-ib-planning" />
                  </ListItemIcon>
                  <span className={classes.reportsListLabel}>
                    IB Planning Operations
                  </span>
                </ListItem>
              </Tooltip>
            ) : null}
            <Tooltip title={displayTitle(props.width, "Pro History")}>
              <ListItem
                button
                classes={{
                  root: `${classes.reportsListItem} ${classes.listItemRoot}`,
                  selected: classes.listItemSelected,
                }}
                data-moduleurl={NAV_URLS.REPORT_PRO_HISTORY}
                selected={activeModule === NAV_URLS.REPORT_PRO_HISTORY}
              >
                <ListItemIcon classes={{ root: classes.iconStyle }}>
                  <i className="icon-icon_history" />
                </ListItemIcon>
                Pro History
              </ListItem>
            </Tooltip>
            {isAdmin && (
              <>
                <Tooltip title={displayTitle(props.width, "Dock Compliance")}>
                  <ListItem
                    button
                    classes={{
                      root: `${classes.reportsListItem} ${classes.listItemRoot}`,
                      selected: classes.listItemSelected,
                    }}
                    data-moduleurl={NAV_URLS.REPORT_DOCK_COMPLIANCE}
                    selected={activeModule === NAV_URLS.REPORT_DOCK_COMPLIANCE}
                  >
                    <ListItemIcon classes={{ root: classes.iconStyle }}>
                      <DnsOutlinedIcon
                        className={`${classes.dcrIcon} icon-dcr`}
                      />
                    </ListItemIcon>
                    <span className={classes.reportsListLabel}>
                      Dock Compliance
                    </span>
                  </ListItem>
                </Tooltip>
                <Tooltip title={displayTitle(props.width, "KPI Summary")}>
                  <ListItem
                    button
                    classes={{
                      root: `${classes.reportsListItem} ${classes.listItemRoot}`,
                      selected: classes.listItemSelected,
                    }}
                    data-moduleurl={NAV_URLS.REPORT_KPI_SUMMARY}
                    selected={activeModule === NAV_URLS.REPORT_KPI_SUMMARY}
                  >
                    <ListItemIcon classes={{ root: classes.iconStyle }}>
                      <TrendingUpIcon className={`${classes.kpiIcon}`} />
                    </ListItemIcon>
                    KPI Summary
                  </ListItem>
                </Tooltip>
                <Tooltip
                  title={displayTitle(props.width, "Next Stop Compliance")}
                >
                  <ListItem
                    button
                    classes={{
                      root: `${classes.reportsListItem} ${classes.listItemRoot}`,
                      selected: classes.listItemSelected,
                    }}
                    data-moduleurl={NAV_URLS.NEXT_STOP_COMPLIANCE}
                    selected={activeModule === NAV_URLS.NEXT_STOP_COMPLIANCE}
                    disabled={!enableNextStopComplianceReport}
                  >
                    <ListItemIcon classes={{ root: classes.iconStyle }}>
                      <NextStopComplianceMarker
                        color={
                          activeModule === NAV_URLS.NEXT_STOP_COMPLIANCE
                            ? theme.selectedStopMarkerColor
                            : theme.HeaderSelectedText
                        }
                        className={`${classes.dcrIcon} icon-dcr`}
                      />
                    </ListItemIcon>
                    <span className={classes.reportsListLabel}>
                      Next Stop Compliance
                    </span>
                  </ListItem>
                </Tooltip>
              </>
            )}
            {hasAccess([USER_ROLE.DISPATCHER, USER_ROLE.MANAGER]) && (
              <Tooltip
                title={displayTitle(props.width, "Driver Performance Historic")}
              >
                <ListItem
                  button
                  classes={{
                    root: `${classes.reportsListItem} ${classes.listItemRoot}`,
                    selected: classes.listItemSelected,
                  }}
                  data-moduleurl={NAV_URLS.REPORT_DRIVER_PERFORMANCE}
                  selected={activeModule === NAV_URLS.REPORT_DRIVER_PERFORMANCE}
                  disabled={!enableDriverPerformanceHistoricReport}
                >
                  <ListItemIcon classes={{ root: classes.iconStyle }}>
                    <DriverPerformanceHistoricMarker
                      color={
                        activeModule === NAV_URLS.REPORT_DRIVER_PERFORMANCE
                          ? theme.selectedStopMarkerColor
                          : theme.HeaderSelectedText
                      }
                      className={`${classes.dcrIcon} icon-dcr`}
                    />
                  </ListItemIcon>
                  <span className={classes.reportsListLabel}>
                    Driver Performance Historic
                  </span>
                </ListItem>
              </Tooltip>
            )}
            <Tooltip title={displayTitle(props.width, "Events Stream")}>
              <ListItem
                button
                classes={{
                  root: `${classes.reportsListItem} ${classes.listItemRoot}`,
                  selected: classes.listItemSelected,
                }}
                data-moduleurl={NAV_URLS.REPORT_SHIPMENTS_EVENT_STREAM}
                selected={
                  activeModule === NAV_URLS.REPORT_SHIPMENTS_EVENT_STREAM
                }
              >
                <ListItemIcon classes={{ root: classes.iconStyle }}>
                  <EventNoteSharp className={classes.mergedCustomerIcon} />
                </ListItemIcon>
                <span className={classes.reportsListLabel}>Events Stream</span>
                </ListItem>
            </Tooltip>
            <Tooltip title={displayTitle(props.width, 'Records Lookup')}>
            <ListItem
                button
                classes={{
                  root: `${classes.reportsListItem} ${classes.listItemRoot}`,
                  selected: classes.listItemSelected
                }}
                data-moduleurl={NAV_URLS.REPORT_RECORDS_lOOKUP}
                selected={activeModule === NAV_URLS.REPORT_RECORDS_lOOKUP}
                disabled={!enableRecordsLookupReport}>
                <ListItemIcon classes={{ root: classes.iconStyle }}>
                  <NotesIcon className={`${classes.kpiIcon}`} />
                </ListItemIcon>
                <span className={classes.reportsListLabel}>Records Lookup</span>
              </ListItem>
            </Tooltip>
            {hasAccess() && (
              <Tooltip title={displayTitle(props.width, 'Usage Report')}>
                <ListItem
                  button
                  classes={{
                    root: `${classes.reportsListItem} ${classes.listItemRoot}`,
                    selected: classes.listItemSelected
                  }}
                  data-moduleurl={NAV_URLS.REPORT_USAGE_REPORT}
                  selected={activeModule === NAV_URLS.REPORT_USAGE_REPORT}>
                  <ListItemIcon classes={{ root: classes.iconStyle }}>
                    <AssessmentIcon className={`${classes.kpiIcon}`} />
                  </ListItemIcon>
                  <span className={classes.reportsListLabel}>Usage Report</span>
                </ListItem>
              </Tooltip>
            )}
            <Tooltip title={displayTitle(props.width, 'Route Audit')}>
              <ListItem
                button
                classes={{
                  root: `${classes.reportsListItem} ${classes.listItemRoot}`,
                  selected: classes.listItemSelected
                }}
                data-moduleurl={NAV_URLS.REPORT_ROUTE_AUDIT}
                selected={activeModule === NAV_URLS.REPORT_ROUTE_AUDIT}
                disabled={!enableRouteAudit}>
                <ListItemIcon classes={{ root: classes.iconStyle }}>
                  <VerifiedUserOutlinedIcon className={`${classes.kpiIcon}`} />
                </ListItemIcon>
                <span className={classes.reportsListLabel}>Route Audit</span>
              </ListItem>
            </Tooltip>
          </List>
        </Collapse>
      </List>
    </div>
  );
};

export default compose(
  withWidth(),
  withStyles(styles),
  withTheme(),
  withUserProfile
)(ReportList);
